import {
  infiniteQueryOptions,
  QueryFunctionContext,
  UseInfiniteQueryOptions,
} from "@tanstack/react-query";
import {
  fetchPaginatedUserWithSellerInfos,
  UserWithSellerInfosResult,
} from "./fetchPaginatedUserWithSellerInfos";

export const createUserWithSellerInfosQueryOptions = (
  filters: Record<string, any>,
  limit = 10,
  options?: Partial<
    UseInfiniteQueryOptions<
      UserWithSellerInfosResult,
      Error,
      UserWithSellerInfosResult,
      [string, Record<string, any>],
      string | undefined
    >
  >
) =>
  infiniteQueryOptions<
    UserWithSellerInfosResult,
    Error,
    UserWithSellerInfosResult,
    [string, Record<string, any>],
    string | undefined
  >({
    queryKey: ["user-with-seller-infos", filters],
    queryFn: (ctx: QueryFunctionContext<[string, Record<string, any>], string | undefined>) => {
      const [, filtersFromKey] = ctx.queryKey;
      return fetchPaginatedUserWithSellerInfos(filtersFromKey, ctx.pageParam, limit);
    },
    getNextPageParam: (lastPage) =>
      lastPage.sellerInfos?.length > 0 && typeof lastPage.nextToken === "string"
        ? lastPage.nextToken
        : undefined,
    initialPageParam: undefined,
    ...options,
  });
